import React, { useState, useEffect } from 'react';
import metadata from '../../assets/json/metadata.json';

const withClearCache = (OriginalComponent) => {
  const ClearCacheComponent = (props) => {
    const [isLatestBuild, setIsLatestBuild] = useState(false);

    useEffect(() => {
      const checkBuild = async () => {
        const build_number = await localStorage.getItem('sso_build_no');
        if (metadata.build_number !== parseInt(build_number)) {
          setIsLatestBuild(false);
          refreshCacheAndReload();
        } else {
          setIsLatestBuild(true);
        }
      };
      checkBuild();
    }, []);

    const refreshCacheAndReload = () => {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then((names) => {
          for (const name of names) {
            caches.delete(name);
          }
        });
      }
      // delete browser cache and hard reload
      localStorage.setItem('sso_build_no', metadata.build_number);
      window.location.reload();
    };

    return isLatestBuild ? <OriginalComponent {...props} /> : null;
  };

  return ClearCacheComponent;
};

export default withClearCache;
